import { SWRFetcher } from '@commenda/utils';
import { Job } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';

export enum JobStatusEnum {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  NOT_STARTED = 'NOT_STARTED',
}

export type TJob = {
  isJobCompleted: boolean;
  job: Job;
  totalTasks: number;
  completedTasks: number;
  status: JobStatusEnum;
};

export function useJob(jobId: string | null, token: string) {
  const {
    data,
    error,
    mutate,
  }: {
    mutate: KeyedMutator<unknown>;
    error: unknown;
    data: TJob;
  } = useSWR(
    jobId ? `job/${jobId}` : null,
    jobId ? SWRFetcher({ method: 'GET' }, token) : null
  );

  return {
    data,
    error,
    mutate,
  };
}
